import React from 'react';
import { observer } from 'mobx-react';
import AnaBooking from '../ana_booking/ana_booking';

// apassはANAと同じテーブル・同じAPIを使い、reservation_typeで出し分けている。
// 画面もANAと同一構成のため、reservationTypeを差し替えて再利用する
const ApassBooking = observer(() => <AnaBooking reservationType="apass" />);

export default ApassBooking;
